import { ChangePasswordRequestSchema, ChangePasswordResponseSchema } from './change-password.schema';
/**
 * Change Password Endpoint Contract
 * Allows authenticated users to change their password
 */ export const changePasswordContract = {
    method: 'POST',
    path: '/api/v2/profile/change-password',
    description: 'Change the authenticated user password',
    requestSchema: ChangePasswordRequestSchema,
    responseSchema: ChangePasswordResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - invalid or missing token or incorrect current password'
        }
    }
};

//# sourceMappingURL=change-password.contract.js.map